import { render } from "./PdfDialog.vue?vue&type=template&id=f5889aba&scoped=true"
import script from "./PdfDialog.vue?vue&type=script&lang=js"
export * from "./PdfDialog.vue?vue&type=script&lang=js"

import "./PdfDialog.vue?vue&type=style&index=0&id=f5889aba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5889aba"]])

export default __exports__